const ContentButton = ({isActive, onClick, className = '', children}) => {

    let classNames = ['rounded-xl', 'border-2', 'cursor-pointer'];
    
    // Add pt-4 only if the passed in className doesn't contain any class starting with pt-
    if (!/\bpt-\S+/.test(className)) {
        classNames.push('pt-4');
    }

    if(isActive) {
        classNames.push('border-purple bg-purple text-white');
    } else {
        classNames.push('border-blue bg-white text-blue hover:text-purple hover:border-purple');
    }

    classNames.push(className);

    return (
        <div className={classNames.join(' ')} onClick={onClick}>{children}</div>
    );
};

export default ContentButton;
